import NotFound from '@/src/components/NotFound';
import Container from '@/src/components/ui/container';
import Typography from '@/src/components/ui/typography';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import React, { FC, ReactNode } from 'react';
import BAGIMage from '@/public/bag.svg';

type SearchConatinerProps = {
  children: ReactNode;
  title: string;
  subtitle?: string;
  length: number;
  noRsultTitle?: string;
  smallHeading?: string;
};
const SearchConatiner: FC<SearchConatinerProps> = ({
  children,
  title,
  subtitle,
  smallHeading,
  length,
  noRsultTitle,
}) => {
  const t = useTranslations('search');
  if (!length)
    return (
      <div className="flex w-full flex-col pb-2 lg:pb-4">
        <Container>
          <div className="flex flex-col pb-4">
            {smallHeading && (
              <Typography weight={'medium'} className="my-6" variant={'h6'} component={'h3'}>
                {smallHeading}
              </Typography>
            )}
            <Typography variant={'h4'} component={'h1'} color={'text'} weight={'medium'}>
              {title} {subtitle && <>&quot;{subtitle}&quot;</>}
            </Typography>
          </div>
          <div>
            {' '}
            <NotFound
              title={noRsultTitle ?? t('NoResult')}
              node={<Image src={BAGIMage} alt="not found" width={150} height={150} />}
            />
          </div>
        </Container>
      </div>
    );

  return (
    <div className="flex w-full flex-col pb-8">
      <Container>
        <div className="flex flex-col pb-2 lg:pb-4">
          <Typography variant={'h4'} component={'h1'} color={'text'} weight={'medium'}>
            {title} {subtitle && <>&quot;{subtitle}&quot;</>}
          </Typography>
        </div>
        <div>{children}</div>
      </Container>
    </div>
  );
};

export default SearchConatiner;
